require('./modal.js');

Pegasus.IntrinsicContentConflictPresenter = Pegasus.Modal.extend({
  title: Pegasus.computed.t('title.update_template_width'),

  width: '600px',

  classNames: ['vr-resize-template-to-width'],

  submitDisabled: false,
  cancelEnabled: false,
  hasFooter: true,

  bodyTemplateName: 'modals/intrinsic_content_conflict',
  submitText: Pegasus.computed.t('g.yes'),

  headerClassName: 'editor-modal-header',
  bodyClassName: 'editor-modal-body',
  footerClassName: 'editor-modal-footer',

  didSubmit: function(){
    this.set('presenter.content.electedTemplateWidth', this.get('presenter.content.intrinsicTemplateWidth'));
    this.get('presenter.content').destroy();
    this._super();
  }
});
